<template>
  <div class="search-result">
    <div class="result-header">
      <template v-if="content.main">
        <div>
          {{ content.main.summary }}。——<a target="_blank" :href="content.main.link">{{
            content.main.title
          }}</a>
        </div>
      </template>
      <template v-else>
        {{ content }}
      </template>
    </div>
    <div class="line-dashed"></div>
    <template v-if="!!content.others && !!content.others.length">
      <div class="result-body">
        <div>其他文档</div>
        <div
          v-for="(item, index) in content.others"
          :key="`content-item-${index}`"
          class="content-item"
        >
          <a target="_blank" :href="item.link">{{ item.title }}</a>
        </div>
      </div>
      <div class="line-dashed"></div>
    </template>
    <div v-html="resultTip" class="result-footer" @click="selectFeedback"></div>
  </div>
</template>

<script>
export default {
  name: 'search-result',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    content() {
      return this.data.content
    },
    resultTip() {
      return this.data.courtesy
        .replace(/%action%/, '<span class="system-feedback">')
        .replace(/%\/action%/, '</span>')
    }
  },
  methods: {
    selectFeedback(event) {
      this.$emit('selectFeedback', event)
    }
  }
}
</script>
